// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background-color: #000;
  color: #fff;
  padding: 4rem 0 2rem;
  border-top: 4px solid #ffbb00;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr auto;
  gap: 4rem;
  margin-bottom: 3rem;
}

.footer-section h3,
.footer-section h4 {
  color: #ffbb00;
  font-weight: 900;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-section h3 {
  font-size: 2rem;
}

.footer-section h4 {
  font-size: 1.3rem;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.footer-logo {
  height: 50px;
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.footer-tagline {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #ccc;
  margin: 0;
}

.footer-tagline strong {
  color: #ffbb00;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.footer-section ul li a {
  color: #ccc;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease, transform 0.3s ease;
  display: inline-block;
}

.footer-section ul li a:hover {
  color: #ffbb00;
  transform: translateX(5px);
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-contact p {
  margin: 0;
}

.footer-contact a {
  color: #ccc;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-contact a:hover {
  color: #ffbb00;
}

.footer-badge-frame {
  display: block;
  width: 150px;
  height: 270px;
  border: 0;
  border-radius: 10px;
  /* Credly's embed is transparent with dark text */
  background: #fff;
}

.footer-bottom {
  border-top: 1px solid #333;
  padding-top: 2rem;
  text-align: center;
}

.footer-bottom p {
  color: #888;
  font-size: 0.9rem;
  margin: 0;
}

@media (max-width: 992px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
  }

  .footer-brand {
    grid-column: 1 / -1;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 3rem 0 1.5rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2.5rem;
    margin-bottom: 2rem;
  }

  .footer-brand {
    grid-column: 1;
    text-align: center;
  }

  .footer-logo {
    margin: 0 auto;
  }

  .footer-section {
    text-align: center;
  }

  .footer-section ul {
    align-items: center;
  }

  .footer-contact {
    align-items: center;
  }

  .footer-badge-frame {
    margin: 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".footer {\n  background-color: #000;\n  color: #fff;\n  padding: 4rem 0 2rem;\n  border-top: 4px solid #ffbb00;\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr auto;\n  gap: 4rem;\n  margin-bottom: 3rem;\n}\n\n.footer-section h3,\n.footer-section h4 {\n  color: #ffbb00;\n  font-weight: 900;\n  margin-bottom: 1.5rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.footer-section h3 {\n  font-size: 2rem;\n}\n\n.footer-section h4 {\n  font-size: 1.3rem;\n}\n\n.footer-brand {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.footer-logo {\n  height: 50px;\n  width: auto;\n  object-fit: contain;\n  filter: brightness(0) invert(1);\n}\n\n.footer-tagline {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  color: #ccc;\n  margin: 0;\n}\n\n.footer-tagline strong {\n  color: #ffbb00;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.footer-section ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.footer-section ul li a {\n  color: #ccc;\n  text-decoration: none;\n  font-size: 1rem;\n  transition: color 0.3s ease, transform 0.3s ease;\n  display: inline-block;\n}\n\n.footer-section ul li a:hover {\n  color: #ffbb00;\n  transform: translateX(5px);\n}\n\n.footer-contact {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.footer-contact p {\n  margin: 0;\n}\n\n.footer-contact a {\n  color: #ccc;\n  text-decoration: none;\n  font-size: 1rem;\n  transition: color 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.footer-contact a:hover {\n  color: #ffbb00;\n}\n\n.footer-badge-frame {\n  display: block;\n  width: 150px;\n  height: 270px;\n  border: 0;\n  border-radius: 10px;\n  /* Credly's embed is transparent with dark text */\n  background: #fff;\n}\n\n.footer-bottom {\n  border-top: 1px solid #333;\n  padding-top: 2rem;\n  text-align: center;\n}\n\n.footer-bottom p {\n  color: #888;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n@media (max-width: 992px) {\n  .footer-content {\n    grid-template-columns: 1fr 1fr;\n    gap: 3rem;\n  }\n\n  .footer-brand {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer {\n    padding: 3rem 0 1.5rem;\n  }\n\n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: 2.5rem;\n    margin-bottom: 2rem;\n  }\n\n  .footer-brand {\n    grid-column: 1;\n    text-align: center;\n  }\n\n  .footer-logo {\n    margin: 0 auto;\n  }\n\n  .footer-section {\n    text-align: center;\n  }\n\n  .footer-section ul {\n    align-items: center;\n  }\n\n  .footer-contact {\n    align-items: center;\n  }\n\n  .footer-badge-frame {\n    margin: 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
